/**
 * Meta Facebook Pixel 埋点
 * 参考：https://www.facebook.com/business/help/952192354843755
 * 像素 ID、测试事件码通过环境变量配置，Access Token 仅用于服务端 Conversions API，勿放在前端。
 */

const PIXEL_ID = process.env.NEXT_PUBLIC_FB_PIXEL_ID || "";
const TEST_EVENT_CODE = process.env.NEXT_PUBLIC_FB_PIXEL_TEST_CODE || "";

export function getFbPixelId() {
  return PIXEL_ID;
}

export function isFbPixelEnabled() {
  return typeof window !== "undefined" && PIXEL_ID && typeof window.fbq === "function";
}

/**
 * 初始化 Pixel（由 base snippet 调用，此处仅封装 track 等）
 * 实际 init 在 _app 的 Script 内执行，保证首屏即加载。
 */
export function initFbPixel() {
  if (typeof window === "undefined" || !PIXEL_ID) return;
  if (window.fbq) {
    window.fbq("init", PIXEL_ID);
    return;
  }
  // 若 Script 未加载完，由 base snippet 负责 init
}

/**
 * 发送事件
 * @param {string} eventName - 标准事件如 'PageView' | 'ViewContent' | 'Lead' | 'CompleteRegistration' | 'Purchase' 等
 * @param {object} [params] - 事件参数
 * @param {object} [options] - { test_event_code: 'TESTxxxx' } 用于在 Events Manager 中识别测试事件
 */
export function trackFbPixel(eventName, params, options = {}) {
  if (!isFbPixelEnabled()) return;
  const opts = { ...options };
  if (TEST_EVENT_CODE && !opts.test_event_code) {
    opts.test_event_code = TEST_EVENT_CODE;
  }
  try {
    if (Object.keys(opts).length > 0) {
      window.fbq("track", eventName, params || {}, opts);
    } else {
      window.fbq("track", eventName, params);
    }
  } catch (e) {
    console.warn("[Facebook Pixel] track error", eventName, e);
  }
}

/**
 * 单次访问埋点（SPA 路由变化时调用）
 */
export function trackFbPixelPageView() {
  trackFbPixel("PageView");
}
